<template>
    <main>
     <div>
            <!-- <van-button type="primary" text="显示遮罩层" @click="show = true" /> -->
        <van-overlay :show="false">
            <div class="wrapper" @click.stop>
            <div class="block">
                <img src="../assets/img/jindutiuao.png" alt="">
                <van-progress :show-pivot="false" color="green" :percentage="50" stroke-width="8" />
                <p>正在查询...</p>
            </div>
            </div>
        </van-overlay>      
     </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            count:"",//倒计时
        }
    },

    mounted(){
     this.clickJump()
    },

    methods: {
  //几秒后进入跳转页面
    clickJump(){
        const timejump = 3;
        if(!this.timer){
            this.count = timejump ;
            this.show = false;
            this.timer = setInterval(()=>{
            if(this.count > 0 && this.count <= timejump ){
                this.count--;
            }else{
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                //跳转的页面写在此处
                this.$router.push({path: '/pay'});
            }
          },1000)
        }
    },

 }
}
</script>

<style scoped>
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

.block {
    width: 490px;
    height: 390px;
    background-color: #fff;
  }

.block img {
    margin: 60px 80px;
}

.block p {
    margin-top: 20px;
    text-align: center;   
}

/deep/.van-progress {
    width: 370px;
    /* height: 20px; */
    margin-left: 50px;
}

</style>




// WEBPACK FOOTER //
// src/pages/query.vue